import styled from '@emotion/styled'

import * as ModalViews from '@segment/matcha/components/Modal/Modal.views'

import Image from '@segment/matcha/components/Image'

import * as CopyText from '@segment/matcha/recipes/CopyText'

export const BackgroundImage = styled(Image)`
  width: 100%;
  min-width: 340px;
  border-radius: 8px;
`

export const Modal = styled(ModalViews.Wrapper)`
  position: absolute;
  z-index: 1;
  top: calc(50% - 105px);
  left: calc(50% - 145px);
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    top: calc(50% - 105px);
    left: calc(50% - 179px);
  }
`
export const ModalHead = styled(ModalViews.ModalHead)`
  justify-content: center;
`
export const ModalBody = styled(ModalViews.ModalBody)`
  padding-top: 0px;
  text-align: center;
`
export const Description = styled(CopyText.Description)`
  margin-top: 0px;
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    line-height: 21px;
  }
`
export const ButtonWrapper = styled.div`
  margin-top: 24px;
`
